import { render, staticRenderFns } from "./ProuniPersonalData.vue?vue&type=template&id=b54901e4&"
import script from "./ProuniPersonalData.vue?vue&type=script&lang=ts&"
export * from "./ProuniPersonalData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports